import { TERMINE_SCHICHT_VERKNUEPFUNG_DELETE } from '@/domain/termine/hooks/graphql/mutation';
import {
  DeleteSchichtVerknuepfungMutation,
  DeleteSchichtVerknuepfungMutationVariables,
} from '@/gql/graphql';
import { useMutation } from '@apollo/client/react';

export function useDeleteSchichtVerknuepfung() {
  const [mutate, { loading }] = useMutation<
    DeleteSchichtVerknuepfungMutation,
    DeleteSchichtVerknuepfungMutationVariables
  >(TERMINE_SCHICHT_VERKNUEPFUNG_DELETE, {
    refetchQueries: ['GetTagesDaten'],
    awaitRefetchQueries: true,
  });

  const deleteSchichtVerknuepfung = async (
    variables: DeleteSchichtVerknuepfungMutationVariables,
  ) => {
    const result = await mutate({ variables });
    return result.data?.termine_schichtVerknuepfungDelete;
  };
  return { deleteSchichtVerknuepfung, loading };
}
